<body>
    <!--set cours de change-->
<fieldset id="motiffieldset">
    <legend>Paramêtrage des motifs de rejets</legend>
    <p>structure fichier: &nbsp; col1:groupe,&nbsp;col2:famille,&nbsp;col3:code,&nbsp;col4:libelle,&nbsp;col5:document,&nbsp;col6:rechdocpresentation,&nbsp;col7:collaballoc,&nbsp;col8:delai&nbsp;col9:delai2&nbsp;col10:delai3&nbsp;col11:delai4&nbsp;col12:delai5</p>
    <div class="col-6"style="width: 300px"> Charger fichier
        <input type="file"  #filePicker (change)="onFileChange3($event)" class="form-control" accept=".xls, .xlsx">
    </div>
    <!-- <form [formGroup]="motifform">               
      <div class="searchbar">      
       <input class="search_input" id="dateinf"formControlName="dateinf"type="date"  placeholder="Chercher par Email">
      </div>
      <div class="searchbar">      
        <input class="search_input" id="datesup"formControlName="datesup"type="date"  placeholder="Chercher par Email">
      </div>
      <div class="searchbar"> 
         <a class="search_icon"(click)="filtercours()" style="cursor: pointer;"> <i class="fa fa-search"></i></a>  
      </div>
      <button class="btn btn-primary" (click)="affichertout()"><i class="fa fa-refresh fa-spin"*ngIf="loading"></i>Afficher tout</button>
    </form> -->
   
    <table class="table table-striped" id="relevejointsection" [formGroup]="motifform" style="overflow-x: auto;">
      <thead>
        <tr>
          <th>Date système</th>
          <button type="button" class="btn btn-danger btn-sm" (click)="resetdatesysteme()">Réinitialiser Date système</button>   
        </tr>
      </thead>
      <tbody>
        <tr>
          <td> <input type="date"class="form-control"formControlName="currentdate"/> </td>
        </tr>
      </tbody>
     <thead>
      <tr>
        <th>Délai initiation réclamation</th>
        <th>Délai réclamation avec statut crée</th>
        <th>Délai réclamation avec statut en cours</th>
        <th>Délai réclamation avec statut relancée</th>
        <th>Délai réclamation pour recherche document</th>
        <th>Délai initiation pré-arbitrage</th>
        <th>Délai réponse pré-arbitrage</th>
        <th>Délai initiation arbitrage</th>
        <th>Délai attente Réponse Acquéreur</th>
        <th>Délai décision comité</th>
      </tr>
     </thead>
     <tbody>

      <tr>
     <td> <input type="text"class="form-control"formControlName="initrec"placeholder="initiation réclamation"/> </td>
     <td><input type="text"class="form-control"formControlName="creerec"placeholder="initiation crée"/></td>
     <td><input type="text"class="form-control"formControlName="encoursrec"placeholder="initiation en cours"/></td>
     <td><input type="text"class="form-control"formControlName="relancerec"placeholder="relance"/></td>
     <td><input type="text"class="form-control"formControlName="initrech"placeholder="initrech"/></td>
     <td><input type="text"class="form-control"formControlName="initprearb"placeholder="initiation pré-arbitrage"/></td>
     <td><input type="text"class="form-control"formControlName="repprearb"placeholder="réponse pré-arbitrage"/></td>
     <td><input type="text"class="form-control"formControlName="initarb"placeholder="initiation arbitrage"/></td>
     <td><input type="text"class="form-control"formControlName="repacquireur"placeholder="Délai attente Réponse Acquéreur"/></td>
     <td><input type="text"class="form-control"formControlName="initcomite"placeholder="initiation décision comité"/></td>

    </tr>
     </tbody>
      <thead>
        <tr> 
            <th scope="col">Groupe</th>
            <th scope="col">Famille</th>
            <th scope="col">Code</th>
            <th scope="col">Motif</th>
            <th scope="col">document</th>
            <th scope="col">rech-doc-presentation</th>
            <th scope="col">collab-alloc</th>
            <th scope="col">délai chargeback</th>
            <th scope="col">délai représentation</th>
        </tr>
        </thead>
        <tbody formArrayName="ammounts2">
            <tr *ngFor="let ammount of ammountControls2; let i = index;"[formGroupName]="i">
              <td>
                <textarea name="" id="" cols="15" rows="2"formControlName="groupe"placeholder="groupe"></textarea>
               </td>
               <td>
                <textarea name="" id="" cols="15" rows="2"formControlName="famille"placeholder="famille"></textarea>
               </td>
               <td>
                    <input type="text"class="form-control"formControlName="code"placeholder="code"/>
               </td>
               <td>
                  <textarea name="" id="" cols="30" rows="2"type="text"class="form-control"formControlName="motif"placeholder="motif"></textarea>
               </td>
               <td>
                  <div class="form-group">
                      <select  class="input-field" placeholder="Entrer regime impot" id="activity" style="width: 150px;"formControlName="contientfichier" name="contientfichier" >
                        <option value="Oui">Oui</option>
                        <option value="Non">Non</option>
                      </select>
                  </div>
               </td>
               <td>
                <div class="form-group">
                    <select  class="input-field" placeholder="Entrer regime impot" id="activity" style="width: 150px;"formControlName="rechdocpresentation" name="contientfichier" >
                      <option value="Oui">Oui</option>
                      <option value="Non">Non</option>
                    </select>
                </div>
             </td>
             <td>
              <div class="form-group">
                  <select  class="input-field" placeholder="Entrer regime impot" id="activity" style="width: 150px;"formControlName="collaballoc" name="contientfichier" >
                    <option value="collab">Collaboration</option>
                    <option value="alloc">Allocation</option>
                  </select>
              </div>
           </td>
               <td>
                    <input type="text"class="form-control"formControlName="delai"placeholder="délai"/>
               </td>
               <td>
                    <input type="text"class="form-control"formControlName="delai2"placeholder="délai2"/>
               </td>
              <td>
                      <div>
                      <button type="button" class="btn btn-danger btn-sm" (click)="removeammount2(i)"><span><i class="fa fa-minus-circle"></i></span></button>   
                      </div>
              </td>      
            </tr>
            <tr>
                <td colspan="5"></td>
                <td>
                    <div>
                    <button type="button" class="btn btn-primary mb-2" (click)="addammount2()"><span><i class="fa fa-plus-circle"></i></span></button>   
                    </div>
                   </td>
            </tr>
        </tbody>
        <div class="text-right">
          <button class="btn btn-success" (click)="submit()"><i class="fa fa-refresh fa-spin"*ngIf="loading"></i>Valider</button>
        </div>
        </table>
  </fieldset>
</body>